export function setFavicon (src: string) {
  const headTitle = document.querySelector('head')
  const setFavicon = document.createElement('link')
  setFavicon.setAttribute('rel', 'shortcut icon')
  setFavicon.setAttribute('href', src)
  headTitle?.appendChild(setFavicon)
}
